<template><svg viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6.5L0.75 12.9952L0.75 0.00480951L12 6.5Z"/>
</svg>
</template>